<script lang="ts">
import { AppFormatCurrencyComponent } from "./app-format-currency.ts";
export default AppFormatCurrencyComponent;
</script>

<template>
    {{ formattedValue }}
</template>
